import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/pagination/datatable";
import { Select, Spin } from "antd";
// import dayjs from "dayjs";
import { getApiBaseUrl, GET_RETIREMENT_LIST } from "../Config/Config";
const { Option } = Select;

const RetirementList = () => {
  const [retirementList, setRetirementList] = useState([]);
  const [retirementLoading, setRetirementLoading] = useState(true);
  const [retirementError, setRetirementError] = useState(null);
  const [selectedBlock, setSelectedBlock] = useState(0);
  const [blocks, setBlocks] = useState([]);
  useEffect(() => {
    const fetchBlocks = async () => {
      try {
        const response = await fetch(`${getApiBaseUrl()}/api/getLocationType`);
        const result = await response.json();
        if (result?.ResultData && result?.ResultData?.length > 0) {
          setBlocks(result?.ResultData);
          // setSelectedBlock(result?.ResultData[0].BlockId);
        }
      } catch (err) {
        console.error("Error fetching blocks:", err);
      }
    };
    fetchBlocks();
  }, []);

  const handleBlockChange = (blockId) => {
    setSelectedBlock(blockId);
  };
  // const user = JSON.parse(sessionStorage.getItem("user"));
  // Function to fetch retirement list
  const fetchRetirementList = async () => {
    setRetirementLoading(true);
    try {
      const response = await fetch(
        `${getApiBaseUrl()}${GET_RETIREMENT_LIST}?BlockId=${selectedBlock}&Barcode=0`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setRetirementList(data?.ResultData || []);
    } catch (err) {
      setRetirementError(err.message || "Something went wrong");
    } finally {
      setRetirementLoading(false);
    }
  };

  // Call fetch on component mount
  useEffect(() => {
    fetchRetirementList();
  }, [selectedBlock]);

  console.log(retirementList, retirementLoading, retirementError);

  const columns = [
    {
      title: "Filter ID",
      dataIndex: "Lable",
      key: "Lable",
      sorter: (a, b) => a?.Lable?.length - b?.Lable?.length,
    },
    // {
    //   title: "Code ",
    //   dataIndex: "AHUcode",
    //   key: "AHUcode",
    //   sorter: (a, b) => a.AHUcode - b.AHUcode,
    // },

    {
      title: "Block",
      dataIndex: "locatinname",
      key: "locatinname",
      sorter: (a, b) => a.locatinname.localeCompare(b.locatinname),
    },
    {
      title: " User ID",
      dataIndex: "UserName",
      key: "UserName",
      sorter: (a, b) => a.UserName.localeCompare(b.UserName),
    },
    // {
    //   title: "Status",
    //   dataIndex: "StageName",
    //   key: "StageName",
    //   render: (text) => <span className="badge bg-danger">{text}</span>,
    // },
    // {
    //   title: "Last Change",
    //   dataIndex: "LastCleaningDate",
    //   key: "LastCleaningDate",
    //   sorter: (a, b) =>
    //     new Date(a.LastCleaningDate) - new Date(b.LastCleaningDate),
    //   render: (value) => (value ? dayjs(value).format("DD/MM/YYYY") : ""),
    // },
    {
      title: "Retired Date",
      dataIndex: "updatedon",
      key: "updatedon",
      render: (value) => {
        if (!value) return "";
        const d = new Date(value);

        // Extract UTC parts to avoid local timezone changes
        const day = String(d.getUTCDate()).padStart(2, "0");
        const month = String(d.getUTCMonth() + 1).padStart(2, "0");
        const year = d.getUTCFullYear();

        return `${day}/${month}/${year}`;
      },
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
      sorter: (a, b) => a.remarks.localeCompare(b.remarks),
      render: (text) => (
        <span title={text}>
          {text?.length > 15 ? `${text.slice(0, 15)}...` : text}
        </span>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Retirement List
                  </h4>
                </ol>
              </nav>
              <h6>Manage Retirement List</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li></li>
          </ul>
        </div>
        {/* <div className="row mb-2">
          {blocks.map((block, index) => (
            <div className="col-auto mb-2" key={index}>
              <button
                className={`btn ${
                  activeBlock === block
                    ? "btn-primary"
                    : "btn-light border-primary text-primary"
                }`}
                onClick={() => setActiveBlock(block)}
                type="button"
              >
                {block}
              </button>
            </div>
          ))}
        </div> */}
        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3  ">
            <div className="search-set m-3"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div style={{ minWidth: "250px" }}>
                <label className="fw-bold mb-1 d-block">Select Block:</label>
                <Select
                  style={{ width: "100%" }}
                  value={selectedBlock === 0 ? 0 : selectedBlock} // Ensures "All" is shown when value is 0
                  onChange={handleBlockChange}
                  placeholder="Select Block"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.children
                      ?.toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  <Option value={0}>All</Option>
                  {blocks.map((block) => (
                    <Option key={block.BlockId} value={block.BlockId}>
                      {block.BlockName}
                    </Option>
                  ))}
                </Select>
              </div>
              {/* <div className="dropdown me-2">
                <Link
                  to="#"
                  className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  Category
                </Link>
                <ul className="dropdown-menu  dropdown-menu-end p-3">
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      HEPA
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Pre-Filter
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Bag Filter
                    </Link>
                  </li>
                 
                </ul>
              </div> */}
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {retirementLoading ? (
                <div className="text-center my-4">
                  <Spin size="large" />
                  <p>Loading data...</p>
                </div>
              ) : retirementList?.length > 0 ? (
                <Table columns={columns} dataSource={retirementList} />
              ) : (
                <div className="text-center my-4">
                  <p>No data available</p>
                </div>
              )}

              {/* <Table columns={columns} dataSource={RetirementListData} /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RetirementList;
